import { useState } from "react";
import api from "../api";
import { useConfirm } from "./ConfirmDialog";

export default function LeaksPanel({ state, setState, isAdmin }) {
  const confirm = useConfirm();
  const [inp, setInp] = useState("");
  const [editing, setEditing] = useState(null);
  const [edit, setEdit] = useState({});

  const replace = (leaks) => setState({ ...state, leaks });

  const add = async () => {
    if (!inp.trim()) return;
    const body = { title: inp.trim(), text: "", tag: "Leak zone" };
    await api.post("/leaks", body);
    replace([...state.leaks, body]);
    setInp("");
  };

  const del = async (i) => {
    const l = state.leaks[i];
    const ok = await confirm({
      title: "Delete this leak zone?",
      message: `"${l?.title || ""}"\n\nThis cannot be undone.`,
      confirmLabel: "Delete",
    });
    if (!ok) return;
    await api.delete(`/leaks/${i}`);
    replace(state.leaks.filter((_, j) => j !== i));
  };

  const startEdit = (i) => {
    setEditing(i);
    setEdit({ ...state.leaks[i] });
  };

  const save = async () => {
    const i = editing;
    const { data } = await api.patch(`/leaks/${i}`, edit);
    replace(state.leaks.map((x, j) => (j === i ? { ...x, ...data } : x)));
    setEditing(null);
  };

  return (
    <div data-testid="panel-leaks">
      <div className="sec-head">The Leak Zones</div>
      <div className="sec-desc">
        Where revenue is structurally walking out of the business today.
      </div>
      {isAdmin && (
        <div className="add-row">
          <input
            className="grow"
            placeholder="Leak zone title..."
            value={inp}
            onChange={(e) => setInp(e.target.value)}
            data-testid="leak-input"
          />
          <button className="btn" onClick={add} data-testid="leak-add">
            Add
          </button>
        </div>
      )}
      {state.leaks.map((l, i) => (
        <div className="item" key={l.id || i} data-testid={`leak-${i}`}>
          <div className="item-accent a-red" />
          <div className="item-main">
            {editing === i ? (
              <>
                <input
                  className="inline-edit"
                  value={edit.title}
                  onChange={(e) => setEdit({ ...edit, title: e.target.value })}
                />
                <textarea
                  className="inline-edit"
                  value={edit.text}
                  onChange={(e) => setEdit({ ...edit, text: e.target.value })}
                />
                <button className="btn btn-sm" onClick={save}>
                  Save
                </button>
              </>
            ) : (
              <>
                <div className="item-title">{l.title}</div>
                <div className="item-text">{l.text}</div>
                {l.tag && <span className="item-tag">{l.tag}</span>}
              </>
            )}
          </div>
          {isAdmin && (
            <>
              <button
                className="edit-pencil"
                onClick={() => startEdit(i)}
                data-testid={`leak-${i}-edit`}
              >
                ✎
              </button>
              <button
                className="del-x"
                onClick={() => del(i)}
                data-testid={`leak-${i}-delete`}
              >
                ×
              </button>
            </>
          )}
        </div>
      ))}
    </div>
  );
}
